<template>
<div class="shopdetail-wrap">
    <!-- header -->
    <!-- APP下载页 -->
    <div class="downing" v-if="downing">
        <span></span>
        <b>真铺源 无中介 新上铺源抢先看</b>
        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.example.dc.zupubao">APP下载</a>
        <s @click="downingFun"></s>
    </div>
    <!-- 头部导航 -->
    <div class="shopdetail-header">
        <img class="navBack pull-left" @click.stop="back()" src="../../../static/images/shootShop/back.png" alt="" >
        <ul>
            <li class="myshou" @click="shoucang($event)"></li>
            <li @click="jiucuoFun()"><img src="../../../static/images/shopDetail/jiucuo.png" /></li>
        </ul>
    </div>

    <!-- 查看次数 -->
    <div class="todayCount" id="todayCount" v-show="isTodayCount">    
        <dl>
            <dt><img src="../../../static/images/shopDetail/look-icon1.png" /></dt>
            <dd>
                <h5>本次操作消耗了一次看铺机会</h5>
                <p>今日剩余看铺次数 {{numIndex}}/{{pvCount}}</p>
            </dd>
            <!-- <span><router-link :to="{path:'buymember',query:{shopDetail:1,shopId:id}}">更多机会</router-link></span> -->
            <span @click="goMessageuser('0_13');">更多机会</span>
        </dl>
    </div>

    <div style="width: 7.5rem; height: 1.68rem;" v-if="showDowning"></div>
    <div style="width: 7.5rem; height: .88rem;" v-else></div>

    <!-- content -->
    <div class="shopdetail-content">
        <div class="content-top">
            <p>商铺编号&nbsp;{{shopNumber}}</p>
            <h1>{{shopDetailArr.shopName}}</h1>
            <div v-if="shopTagsArr.length != 0">
                <ul>
                    <li v-for="item in shopTagsArr">{{item}}</li>
                </ul>
            </div>
        </div>
        
        <!-- 轮播图 -->
        <div class="content-lbt"> 
            <!-- 小轮播图 -->
            <div class="lbt-small">
                <div class="lbt-num swiperOne">{{num1}}/{{total1}}</div>

             <!--    <div class="swiper-container swiper-container1 swiper-container-horizontal">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in imgs">
                            <div class="videoImgWrap" @click="tab4()" v-if="index == 0 && videoStr != ''">
                                <img src="../../../static/images/common/video.png" class="videoImg" />
                            </div>

                            <img :src="item" alt :onerror="defaultImg" @click="tab1(item,index)" />

                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div> -->

                <van-swipe :autoplay="0" indicator-color="white" @change="onChange">
                    <van-swipe-item v-for="(item,index) in imgs" :key="index">

                      <div class="videoImgWrap" @click="tab4()" v-if="index == 0 && videoStr != ''">
                          <img src="../../../static/images/common/video.png" class="videoImg" />
                      </div>

                      <img :src="item"
                           alt=""
                           title=""
                           style="width: 100%; height: 4rem;"
                           @click="tab1(item,index)" />
                    </van-swipe-item>
                    <template #indicator>
                        <div class="custom-indicator">
                          <!-- {{num1 + 1}}/{{total1}} -->
                        </div>
                      </template>
                </van-swipe> 


            </div>
            <!-- 视频播放 -->
            <div class="video-wrap">

                <div class="swiper-top">
                    <span @click="tab3()"></span>
                    {{shopDetailArr.areaName}}{{shopDetailArr.road}}
                </div>

                <video
                    id="videoPlay"
                    style="width: 100%; height: 5.2rem; object-fit: fill"
                    controls
                    ref="videosrc">
                </video>
            </div>
        </div>
        
        <!-- 地址 -->
        <div class="address clearfix">
            <h3>{{shopDetailArr.areaName}}-{{shopDetailArr.businessAreaName}}</h3>

            <div class="one fl" v-show="add===2"><p class="look">{{shopDetailArr.areaName}}{{shopDetailArr.road}}{{realAddress}}</p></div>

            <div class="two" v-show="add===1" @click="address()">查看详细地址</div>

            <div v-if="type!=3" class="map" @click="mapBtn()"></div>
        </div>
        
        <!-- 价格 -->
        <div class="price clearfix">
            <dl>
                <dt>{{shopDetailArr.buildArea}}平米</dt>
                <dd>面积</dd>
            </dl>
            <dl>
                <dt>{{shopDetailArr.monthlyRent}}{{unitMonthRent}}</dt>
                <dd>月租金</dd>
            </dl>
            <dl class="dl3" @click="goToMessageuser('0_9')"><!-- goMessageuser('0_9') -->
                <dt v-if="shopDetailArr.transferFee == '0'">无</dt>
                <dt v-else>{{shopDetailArr.transferFee}}{{shopDetailArr.unitTransFerfee}}</dt>
                <dd>转让费</dd>
            </dl>
        </div>

        <!-- 商铺类型 -->
        <div class="shop-type">
            <div @click="goToTel('6')"><!-- goToMessageuser('0_10'); -->
                <img src="../../../static/images/shopDetail/message-icon.png">
                <span>业主直通电话</span><!-- 呼叫顾问在线砍价 -->
            </div>
            <dl>
                <i><img src="../../../static/images/shopDetail/icon1.png"></i>
                <dt>商铺类型</dt>
                <dd v-if="shopDetailArr.typeName">{{shopDetailArr.typeName}}</dd>
                <dd v-else>暂无</dd>
            </dl>
            <dl>
                <i><img src="../../../static/images/shopDetail/icon2.png"></i>
                <dt>所在楼层</dt>
                <dd v-if="shopDetailArr.floor">{{shopDetailArr.floor}}</dd>
                <dd v-else>暂无</dd>
            </dl>
            <dl>
                <i><img src="../../../static/images/shopDetail/icon3.png"></i>
                <dt>付款方式</dt>
                <dd style="color: #4a90e2;" @click="goToMessageuser('0_11')" v-if="shopDetailArr.payType">{{shopDetailArr.payType}}</dd>
                <dd style="color: #4a90e2;" @click="goToMessageuser('0_11')" v-else>暂无</dd>
            </dl>
        </div>
        <!-- 顾问说铺 -->
        <div class="consultant" v-if="shopDetailArr.adviser">
        <!-- <div class="consultant"> -->
            <dl>

                <img :src="guwenImag" class="consultant-img" :onerror="defaultImg1" v-if="guwenImag">
                <img src="../../../static/images/shopDetail/consultant1.png" alt="" class="consultant-img" v-else/>

                <dt>
                   <h3>{{shopDetailArr.linkman}}</h3>
                   <h5>顾问说铺</h5>
                </dt>
                <dd @click="goToMessageuser('0_12');"><img src="../../../static/images/shopDetail/more-shop.png" alt="" /></dd>
            </dl>
            <p v-html="shopDetailArr.adviser"></p>

        </div>
        
        <!-- 已有证照  -->
        <div class="common-title" v-show="shoWshopPapers == 1">
            <i class="xkz-icon"><img src="../../../static/images/shopDetail/xkz-icon.png" alt="" /></i>
            <span>已有证照</span>
        </div>
        <div class="certification" v-show="shoWshopPapers == 1">
            <ul class="clearfix">
                <li v-for="item in shopPapers">
                    <img src="../../../static/images/shopDetail/xkz.png" alt="" />
                    <p>{{item}}</p>
                </li>
            </ul>
        </div>

        <!-- 配套设施  -->
        <div class="common-title" v-show="shoWshopSupportings == 1">
            <i class="sheshi-icon"><img src="../../../static/images/shopDetail/sheshi-icon.png" alt="" /></i>
            <span>配套设施</span>
        </div>
        <div class="sheshi-list clearfix" v-show="shoWshopSupportings == 1">
            <dl>
                <dt class="yan"></dt>
                <dd>烟管道</dd>
            </dl>
            <dl>
                <dt class="xia"></dt>
                <dd>下水</dd>
            </dl>
            <dl>
                <dt class="wai"></dt>
                <dd>外摆区</dd>
            </dl>
            <dl>
                <dt class="ting"></dt>
                <dd>停车位</dd>
            </dl>
            <dl>
                <dt class="tian"></dt>
                <dd>天然气</dd>
            </dl>
            <dl>
                <dt class="shang"></dt>
                <dd>上水</dd>
            </dl>
            <dl>
                <dt class="ming"></dt>
                <dd>明火</dd>
            </dl>
            <dl>
                <dt class="pai"></dt>
                <dd>排污管道</dd>
            </dl>
            <dl>
                <dt class="mei"></dt>
                <dd>煤气</dd>
            </dl>
            <dl>
                <dt class="dian"></dt>
                <dd>380伏</dd>
            </dl>
            <dl>
                <dt class="wzz"></dt>
                <dd>无柱子</dd>
            </dl>
            <dl>
                <dt class="wangluo"></dt>
                <dd>网络</dd>
            </dl>
            <dl>
                <dt class="nuanqi"></dt>
                <dd>含采暖气</dd>
            </dl>
            <dl>
                <dt class="wuyefei"></dt>
                <dd>含物业费</dd>
            </dl>
            <dl>
                <dt class="zhuanxiu"></dt>
                <dd>精装修</dd>
            </dl>
        </div>

        <!-- 周边推荐 -->
        <div class="common-title" v-show="shoWrecommendList == 1">
            <!-- <i class="recommend-icon"><img src="../../../static/images/shopDetail/recommend-icon.png" alt="" /></i> -->
            <span></span>
        </div>
        <div class="detail" v-show="shoWrecommendList == 1">
            <ul>
                <li v-for="(item,index) in recommendList" @click="go(item)">
                    <div class="wrap">
                        <div class="img">
                            <img :src="item.img" alt :onerror="defaultImg" />
                            <div v-if="item.topStatus===1" class="zhiding"></div>
                        </div>
                        <div class="msg">
                            <h4>{{item.shopName}}</h4>
                            <div class="tags" v-if="item.shopTags != ''">
                                <span v-if="index1 < 3" v-for="(item1,index1) in item.shopTags">{{item1}}</span>
                            </div>
                            <p>{{item.monthlyRent}}{{item.unit}}</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

    </div>

    <!-- footer -->
    <div class="shopdetail-footer">
        <img :src="guwenImag" class="consultant2-img" :onerror="defaultImg1" v-if="guwenImag">
        <img src="../../../static/images/shopDetail/consultant2.png" alt="" class="consultant2-img" v-else/>
        <ul>
            <li class="li1" @click="goToMessageuser('0_14');">
                <img src="../../../static/images/shopDetail/footer1-icon.png" alt=""/>
                <span>在线聊</span>
            </li>
            <li class="li2" @click="telPhone('2')"><!-- goToTel('tel') telPhone() -->
                <img src="../../../static/images/shopDetail/footer2-icon.png" alt="" />
                <span>打电话</span>
            </li>
        </ul>
    </div>

    <!-- 热门商铺弹窗 -->
    <div class="popup-wrap" v-if="isPopupShow">
        <div class="popup-box">
            <h3>温馨提示</h3>
            <p>此商铺为热门商铺 仅限找铺会员查看</p>
            <p>升级找铺会员独享最新热门铺源</p>
            <p>同时享有8项专属服务</p>
            <ul>
                <li class="li1" @click="isPopupShow = false">知道了</li>
                <!-- <li @click="goBuymember()">升级找铺会员</li> -->
                <li @click="goMessageuser('0_13');">升级找铺会员</li>
            </ul>
        </div>
    </div>

    <div class="model-tishi" v-if="modelTishi===1">
    <!-- <div class="model-tishi">   -->
        <div class="model">
            <h2>温馨提示</h2>
            <p>
                <!-- 您今日<span class="red">{{pvCount}}次</span>看铺机会已用完，开通会员可继续查看也可明天再来哦~ -->
                您的看铺次数已用完，联系专属顾问，获取更多看铺机会
            </p>
            <div>
                <span @click="modelTishi=0">明天再来</span>
                <!-- <b @click="goMessageuser('0_13');">立即联系</b> -->
                <b>
                    <!-- <router-link :to="{path:'buymember',query:{shopDetail:1,shopId:id}}">立即开通</router-link> -->
                    <router-link :to="{path:'buymember',query:{shopDetail:1,shopId:id,cityId:appCityId}}">立即开通</router-link><!-- zhaopuserve -->
                </b>
            </div>
        </div>
    </div>

    <div class="model-down" v-if="modelDown===1">
        <div class="model">
            <div class="close" @click="modelDown=0"></div>
            <h2>温馨提示</h2>
            <p class="txt">
                <!-- 您今日
                <span class="red">3次</span>看铺机会已用完，可下载app享受更多查看次数，也可开通会员继续查看 -->
                您的看铺次数已用完，联系专属顾问，获取更多看铺机会
            </p>
            <div>
                <span>
                    <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.example.dc.zupubao">APP下载</a>
                </span>
                <b @click="goMessageuser('0_13');">立即联系</b>
                    <!-- <router-link :to="{path:'buymember',query:{shopDetail:1,shopId:id}}">立即开通</router-link> -->
                <!-- </b> -->
            </div>
        </div>
    </div>

</div>     
</template>

<script>
import axios from "axios";
import qs from "qs";

import $1 from '../../../static/js/jquery.min.js';

import {ImagePreview} from 'vant';

import { Image } from 'vant';

export default {
  data() {
    return {
      yijian: true, //一键显示影藏
      type: "", //3是成交
      // shopName:"",//标题
      tel: "", //登录手机号
      code: "", //登录验证吗
      time: 60,
      send: "获取验证码",
      disabled: false, //验证码店家
      sendClass: 0, //验证码颜色
      modelLogin: "", //登录弹窗
      msg: "",
      defaultImg:
        'this.src="' + require("../../../static/images/lookShop/err.png") + '"',
      // browseCount: "", //多少人看了该商铺
      modelPu: "", //找铺转铺弹窗
      modelTxt: "", //转铺找铺
      id: "", //商铺id
      isTodayCount: false,
      add: 1,
      address1: "",
      shou: 0,
      num1: 1,
      title: 0,
      num2: 1,
      tab: 0,
      total1: 1,
      shopTagsArr: [],
      realAddress: "", //店主真实地址
      shopPapers: "", //已有证件
      // license: "", //证照：
      // manageType: "", //当前经营
      shopNumber: "", //商铺编号
      shopSupportings: [], //配套设施
      // useArea: "",
      imgs: "",
      gnote: "",
      dpjs: "",
      iphone: "", //获取店主电话
      // rentType: "",
      businessAreaName: "", //商圈名称
      fenxiangID: "",

      unitMonthRent: "",
      unitTransFerfee: "",
      numIndex: "", // 查看商铺次数
      bolClick: true, // 是否点击
      shopIdObj: "", // 判断是否收藏id
      checkedLook: false, // 判断此商铺是否被查看过
      countNum: false, //
      screen: "",
      screenKey: "",
      sliderIndex: "",
      downing: true, //下载显示隐藏
      titleMsg: "",
      pvCount: "", //查看总数
      modelDown: "",
      modelTishi: "",
      threeNum: "", //三次
      buyMember: "",
      recommendList: "", //推荐列表
      telVal: "", // 委托找铺
      isPopupShow: false, //是否为热门

      isTelError: false, //"手机号码错误提示"

      shopDetailArr: [],

      videoStr: "", //视频
      videosrc: "",

      conId: "", //顾问id 

      showDowning: true,

      appType: "", //app使用

      guWenId: "", //顾问id
      ryUserId: "", //融云id

      appCityId: "", //app城市id

      appParamPhone: "", //app手机号

      guWenTel: "", //顾问手机号

      shoWshopSupportings: 1, //隐藏配套设施
      shoWrecommendList: 1, //隐藏推荐商铺
      shoWshopPapers: 1, //已有证件

      guwenImag: "", //顾问头像

      defaultImg1:
        'this.src="' + require("../../../static/images/shopDetail/consultant2.png") + '"',

    };
  },

  mounted() {
    var that = this;

    this.fenxiangID = getQueryString("url");
    this.msg = this.$route.query.msg;

    // this.type = this.$route.query.type;

    this.id = this.$route.query.shopId || this.fenxiangID;

    this.appType = this.$route.query.app;

    this.ryUserId = this.$route.query.userId;

    this.appCityId = this.$route.query.cityId;

    this.appParamPhone = this.$route.query.paramPhone;

   
    if(this.appType){
        this.downing = false;
        this.showDowning = false;
    }


    let USERS = window.localStorage.getItem("iphone");
    if (USERS) {
      this.telVal = USERS;
      this.phoneData();
    }

    if(this.ryUserId){

        this.phoneData();

    }

    //初始化
    this.init();

    this.init1();

    this.dataPost();

    if (getUrlId("move")) {
        $(".back").hide();
        $(".content").css({ margin: 0 });
    }

    //滚动事件
    var that = this;
    window.onscroll = function() {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop >= 100) {
            that.title = 1;
            $(".tel-msg").hide();
        } else {
            that.title = 0;
        }
    };
  },
  updated() {
    this.fenxiangFun();

    let _this = this;
    setTimeout(function() {
        _this.showBanner();
    }, 100);

  },
  beforeRouteEnter(to, from, next) {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // XXX: 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath);
    } else {
      next();
    }
  },
  methods: {

    downingFun(){
        this.downing = false;
        this.showDowning = false;
    },

    goMessage(){

        let _this = this;

        if (localStorage.token == null) {
            layer.open({
                content: "请先登录",
                skin: "msg",
                time: 2 //2秒后自动关闭
            });
            this.$router.push({
                path: "/login",
                query: { shopDetail: 1, shopId: this.id }
            });
        }else{

            this.$router.push({path:"/messageuser1",query:{conId:this.conId}})
        } 
    },
    
    goToMessageuser(typeId){
    		
    		if(this.appType == "ios"){
            if(this.ryUserId){
                //this.threeAppFun(fun);
                this.threeAppFunNew(typeId);
            }else{
                window.webkit.messageHandlers.currentCookiesMap.postMessage({
                    "body": "buttonActionMessage"
                });
            }
        }else if(this.appType == "android"){
            if(this.ryUserId){
                //this.threeAppFun(fun);
                this.threeAppFunNew(typeId);
            }else{
                // 未登录
                return AndroidDial.showToast("0");
            }
        }else{
            //this.threeFun(fun);
            this.threeFunNew(typeId);
        }
    },
    //直播电话 新增
    goToTel(fun){
    		if(this.appType == "ios"){
            if(this.ryUserId){
                //this.threeAppFun(fun);
                this.threeAppFun(fun);
            }else{
                window.webkit.messageHandlers.currentCookiesMap.postMessage({
                    "body": "buttonActionMessage"
                });
            }
        }else if(this.appType == "android"){
            if(this.ryUserId){
                this.threeAppFun(fun);
                
            }else{
                // 未登录
                return AndroidDial.showToast("0");
            }
        }else{
            this.threeFun(fun);
        }
    },
    

    // 跳转IM
    goMessageuser(typeId){
		
        let _this = this;

        // alert(typeId);

        if(this.appType == "ios"){

            let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
            axios(url,{
                method: 'post',
                params:{
                    senderId: this.ryUserId, //发送人ID
                    targetIds: this.guWenId, //接收人ID
                    shopId: this.id, //商铺ID
                    type: typeId,
                    // source: "1",//  string  是   触发来源 1：详情 2：推荐
                }
            }).then(data => {
                console.log(data);
                 
            }).catch(err => {
                console.log(err)
            });

            window.webkit.messageHandlers.currentCookies.postMessage({
                "body": "buttonActionMessage"
            });

        }else if(this.appType == "android"){

          if(this.ryUserId){
            let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
            axios(url,{
                method: 'post',
                params:{
                    senderId: this.ryUserId, //发送人ID
                    targetIds: this.guWenId, //接收人ID
                    shopId: this.id, //商铺ID
                    type: typeId,
                    // source: "1",//  string  是   触发来源 1：详情 2：推荐
                }
            }).then(data => {
                console.log(data);
            }).catch(err => {
                console.log(err)
            });
            return AndroidDial.showToast("1");
          }else{
            // 未登录
            return AndroidDial.showToast("0");
          }

        }else{

            if (localStorage.token == null) {
                layer.open({
                    content: "请先登录",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
                this.$router.push({
                    path: "/login",
                    query: { shopDetail: 1, shopId: this.id }
                });
            }else{

                let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
                axios(url,{
                    method: 'post',
                    params:{
                        senderId: localStorage.rcUserId, //发送人ID
                        targetIds: this.guWenId, //接收人ID
                        shopId: this.id, //商铺ID
                        type: typeId,
                    }
                }).then(data => {

                    // console.log(data);

                    window.location.href="/messageuser?guwenid=" + this.guWenId;
                     
                }).catch(err => {
                    console.log(err)
                });

            } 
        }
    },

    // 发送系统消息
    systemMessage(){
        let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
        axios(url,{
            method: 'post',
            params:{
                senderId: this.ryUserId, //发送人ID
                targetIds: this.guWenId, //接收人ID
                shopId: this.id, //商铺ID
                type: '0_21',
                // source: "1",//  string  是   触发来源 1：详情 2：推荐
            }
        }).then(data => {
            console.log(data);
             
        }).catch(err => {
            console.log(err)
        });
    },

    //纠错
    jiucuoFun() {
      if (localStorage.token) {
        this.$http(this.changeData() + "/shop/auth/getCorrectionInfo", {
          method: "post",
          params: {
            cityId: this.appCityId || sessionStorage.cityId,
            shopId: this.id
          }
        })
          .then(res => {
            // console.log(res);
            if (res.data.code == 101) {
              if (res.data.flag == true) {
                if (res.data.count == true) {
                  layer.open({
                    content: "每天只能纠错十个铺子哦～请明天再来吧！",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                  });
                } else {
                  this.$router.push({
                    path: "/errorCorrection",
                    query: { id: res.data.shop.id }
                  });
                }
              } else {
                layer.open({
                  content: "已有提交纠错信息且再审核中，不能重复提交！",
                  skin: "msg",
                  time: 2 //2秒后自动关闭
                });
              }
            } else {
              layer.open({
                content: "系统繁忙，请稍后再试",
                skin: "msg",
                time: 2 //2秒后自动关闭
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$router.push({
          path: "/login",
          query: { shopDetail: 1, shopId: this.id }
        });
      }
    },

    init() {

      let _this = this;

      var data = {
        shopId: this.id,
        userId: this.ryUserId || localStorage.rcUserId,
        phone: this.appParamPhone || localStorage.iphone
        // shopId: 274336
      };
      // this.$http.post(this.changeData() + "/shop/getShopDetail", qs.stringify(data)).then(function(res) {
        this.$http.post(this.changeData() + "/shop/getNewShopDetail", qs.stringify(data)).then(function(res) {
            // console.log(res);

            this.titleMsg = res.data.shopDetail.shopName;

            this.shopNumber = res.data.shopDetail.shopNumber; //商铺编号

            this.imgs = res.data.shopDetail.imgs; //轮播图

            this.total1 = res.data.shopDetail.imgsSize; //轮播图

            // this.total = res.data.shopDetail.imgs.length; //轮播图数量
            this.guWenId = res.data.shopDetail.guWenId;
            this.guWenTel = res.data.shopDetail.phone; //顾问手机号

            this.guwenImag = res.data.shopDetail.guwen_imag; //顾问头像

            this.unitTransFerfee = res.data.shopDetail.unitTransFerfee; //转让费
            this.shopDetailArr = res.data.shopDetail; //详情数组
            this.shopSupportings = res.data.shopDetail.shopSupportings; //配套设施
            this.shopTagsArr = res.data.shopDetail.shopTags; //商铺的标签
            this.realAddress = res.data.shopDetail.realAddress; //真实地址
            this.shopPapers = res.data.shopDetail.shopPapers; //已有证件
            this.$refs.videosrc.src = res.data.shopDetail.video; //视频
            this.videoStr = res.data.shopDetail.video; //视频名称
            this.unitMonthRent = res.data.shopDetail.unitMonthRent; //月租金单位
            // this.conId = res.data.shopDetail.conId; //顾问id
            this.lng = res.data.shopDetail.lng;
            this.lat = res.data.shopDetail.lat;
            // this.dpjs = res.data.shopDetail.linkman; //店铺介绍
            // this.recommendList = res.data.shopDetail.recommendList; //店铺推荐


            // setTimeout(function() {
            //     _this.showBanner();
            // }, 100);
            

            if(this.shopSupportings.length == 0){
                this.shoWshopSupportings = 0;
            }
           
            if(this.shopPapers.length == 0){
                this.shoWshopPapers = 0;
            }

            // this.shopSupportings = ['1','2','3','4','5','6','7'];

            try {
                this.shopSupportings.forEach(function(item, index) {
                    $(".sheshi-list dl").forEach(function(item1, index1) {
                        if (item == index1 + 1) {
                            $(item1).addClass("cur");
                        }
                    });
                });
            } catch (e) {
                console.log(e);
            }

          }.bind(this)
        ).catch(function(err) {
          console.log("商店详情页面错误：", err);
        });
    },

    init1() {
      var data = {
        shopId: this.id,
      };
      // this.$http.post(this.changeData() + "/shop/getShopDetail", qs.stringify(data)).then(function(res) {
        this.$http.post(this.changeData() + "/shop/findRecommendList", qs.stringify(data)).then(function(res) {

            console.log(res);

            this.recommendList = res.data.recommendList; //店铺推荐

            console.log(this.recommendList);

            if(this.recommendList.length == 0){
                this.shoWrecommendList = 0;
            }

          }.bind(this)
        ).catch(function(err) {
          console.log("商店详情页面错误：", err);
        });
    },

    // 微信分享
    fenxiangFun() {
        var that = this;
        var data = {
            url: window.location.href.split("#")[0]
        };
        this.$http.post(this.changeData() + "/member/weChatShare", qs.stringify(data)).then(
            function(res) {
                wx.config({
                    //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature, // 必填，签名
                    jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"] // 必填，需要使用的JS接口列表
                });

                wx.ready(function() {
                    wx.onMenuShareAppMessage({
                        title: that.titleMsg, // 分享标题
                        desc: "租铺卖铺找优铺", // 分享描述
                        link: window.location.href.split("#")[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: that.imgs[0], // 分享图标
                        type: "", // 分享类型,music、video或link，不填默认为link
                        dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                        success: function() {
                          // 用户点击了分享后执行的回调函数
                        }
                    });
                    //分享到朋友圈
                    wx.onMenuShareTimeline({
                        title: that.titleMsg, // 分享标题
                        link: window.location.href.split("#")[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: that.imgs[0], // 分享图标
                        success: function() {
                            // 用户点击了分享后执行的回调函数
                        }
                    });
                });
                wx.error(function(res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                });
            }.bind(this)
        )
        .catch(function(err) {
            console.log("商店详情页面错误：", err);
        });
    },

    showBanner() {
        var that = this;
        var swiper1 = new Swiper(".swiper-container1", {
            on: {
                slideChangeTransitionEnd: function() {
                    that.sliderIndex = this.activeIndex;
                    $(".swiperOne").text(1 + this.activeIndex + "/" + that.total1);
                }
            }
        });
    },

    // 轮播图索引
    onChange(index) {
      // console.log('当前 Swipe 索引：' + index);
      this.num1 = index + 1;
    },

    tab1(item,index) {
        // $(".bannerBig").show();
        var that = this;

        var imgArr = [];

        this.imgs.forEach(item =>{
           imgArr.push(item.split("?")[0]);
        });

        // console.log(imgArr);

        ImagePreview({
            images: imgArr,
            showIndex:true,
            loop:false, //是否循环播放
            startPosition: index
        })
    },

    tab3() {
        $(".video-wrap").hide();
        if(this.appType == "ios"){
            window.webkit.messageHandlers.currentCookiesBack.postMessage({
                "body": "buttonActionMessage"
            });
        }
    },
    tab4() {
        $(".video-wrap").show();
        document.getElementById("videoPlay").play();
        if(this.appType == "ios"){
            window.webkit.messageHandlers.currentCookiesPhoto.postMessage({
                "body": "buttonActionMessage"
            });
        }
    },
    
    // 返回按钮
    back() {
        // alert(this.$route.query.url)
        if (this.msg && localStorage.iphone) {
            this.$router.push({ path: "/message" });
        } else if (localStorage.iphone && this.$route.query.shopOther) {
            this.$router.push({ path: "/message" });
        } else if (localStorage.iphone && this.$route.query.collectOther) {
            this.$router.push({ path: "/collect" });
        } else if ( this.$route.query.shopMap || this.$route.query.buyMember || this.fenxiangID) {
            this.$router.push({ path: "/lookShop"});
        } else if (this.$route.query.home) {
            this.$router.push({ path: "/home" });
        } else if (this.$route.query.zhaopudetail) {
            this.$router.push({ path: "/zhaopudetail" });
        }else if (this.$route.query.collect) {
            this.$router.push({ path: "/collect" });
        } else if (this.$route.query.url) {
            this.$router.push({
                path: this.$route.query.url,
                query: {
                    urlType: this.$route.query.urlType,
                    shopId: this.$route.query.shopId
                }
            });
        } else if (this.$route.query.myPublish) {
            this.$router.push({
                path: "/myPublish",
                query: { urlType: this.$route.query.urlType }
            });
        } else if (this.$route.query.shopDetail) {
            this.$router.go(-1);
            window.scrollTo("0", "0");
        } else if (this.$route.query.lookShop) {
            this.$router.push({ path: "/lookShop" });
        } else {
            this.$router.push({ path: "/lookShop" });
        }
    },

    // 页面初始化
    dataPost() {
        let url = this.changeData() + "/shop/shopCheckedRecords";

        axios(url, {
            method: "post",
            params: {
                cityId: this.appCityId || sessionStorage.cityId,
                shopId: this.id,
                type: "0",
                paramPhone: this.appParamPhone || sessionStorage.iphone,
                authentication: this.ryUserId || sessionStorage.userId
                // roof: "0"
            }
        }).then(data => {
            // console.log(data);
            if (data.data.code == "101") {
                this.shopIdObj = data.data.shopId;

                 // layer.open({
                 //          content: data.data.checkedStatus,
                 //          skin: "msg",
                 //          time: 100 //2秒后自动关闭
                 //      });


                if (data.data.checkedStatus == 'true') {
                    // 'true' 查看过  false 没有查看过
                    this.checkedLook = true;
                    this.add = 2;
                } else {
                    this.checkedLook = false;
                }
                if (data.data.count == 1) {
                    this.countNum = true;
                }
                if (data.data.collectionStatus == "true") {
                    $(".myshou").addClass("cur");
                }
            } else if (data.data.code == "201") {
                localStorage.clear();
            }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //直拨店主电话，查看详细地址，地图
    threeFun(fun) {
        let that = this;
        if (localStorage.token == null) {
            layer.open({
                content: "请先登录",
                skin: "msg",
                time: 2 //2秒后自动关闭
            });
            this.$router.push({
                path: "/login",
                query: { shopDetail: 1, shopId: this.id }
            });
        } else {
            axios(this.changeData() + "/shop/shopCheckedRecords", {
                method: "post",
                params: {
                    cityId: this.appCityId || sessionStorage.cityId,
                    shopId: this.id,
                    type: "1",
                    // roof: "0"
                }
            }).then(data => {
                // console.log(data);
                if (data.data.code == "101") {
                   
                    // if (data.data.isHot == false) {

                    //     this.isPopupShow = true;
                    // } else {
                        this.numIndex = data.data.count;
                        this.pvCount = data.data.pvCount;
                        if (this.checkedLook == true) {
                            //已经看过
                            this.lookFun(fun);
                        } else { 
                            if (data.data.countStatus == false) {
                                //已经看了10次了
                                this.modelTishi = 1;
                            } else {
                                if (data.data.memberType == "2") {
                                    //不是会员
                                    if (data.data.MlimitCountStatus == false) {
                                        //表示三套已经看完
                                        this.modelDown = 1;
                                    } else {
                                        if (this.bolClick) {

                                            // this.isTodayCount = true;
                                            // setTimeout(function() {
                                            //     that.isTodayCount = false;
                                            // }, 2000);

                                            // $(".todayCount").show(3000).animate();

                                            //$1("#todayCount").fadeIn();

                                            setTimeout(function() {
                                                $1("#todayCount").fadeOut();
                                            }, 2000);

                                            this.bolClick = false;

                                        }
                                        this.checkedLook = true;
                                        this.lookFun(fun);
                                    }
                                } else {
                                   //会员
                                   if (this.bolClick) {

                                        // this.isTodayCount = true;
                                        // setTimeout(function() {
                                        //     that.isTodayCount = false;
                                        // }, 2000);

                                        //$1("#todayCount").fadeIn();

                                        setTimeout(function() {
                                            $1("#todayCount").fadeOut();
                                        }, 2000);


                                        this.bolClick = false;
                                    }
                                    this.checkedLook = true;
                                    this.lookFun(fun);
                                }
                            }
                        }

                    // }

                } else if (data.data.code == "201") {
                    localStorage.clear();
                    layer.open({
                        content: "请先登录",
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                    this.$router.push({
                        path: "/login",
                        query: { shopDetail: 1, shopId: this.id }
                    });
                } else {
                    layer.open({
                        content: "系统繁忙，请稍后再试",
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                }
            }).catch(err => {
                console.log(err);
            });
        }
    },

    //app端直拨店主电话，查看详细地址，地图
    threeAppFun(fun) {
        let that = this;

        axios(this.changeData() + "/shop/shopCheckedRecords", {
            method: "post",
            params: {
                cityId: this.appCityId,
                shopId: this.id,
                type: "1",
                paramPhone: this.appParamPhone,
                authentication: this.ryUserId
                // roof: "0"
            }
        }).then(data => {
            // console.log(data);
            if (data.data.code == "101") {
                // if (data.data.isHot == false) {
                //     this.isPopupShow = true;
                // } else {
                    this.numIndex = data.data.count;
                    this.pvCount = data.data.pvCount;
                    if (this.checkedLook == true) {
                        //已经看过
                        this.lookFun(fun);
                    } else { 
                        if (data.data.countStatus == false) {
                            //已经看了10次了
                            //this.modelTishi = 1;
                            if(this.appType == "android"){
                            		//安卓调用app原生弹框
                            		this.s(); 
                            }else{
                            		//ios调用app原生弹框
                            		webkit.messageHandlers.iosPopView.postMessage(null)
                            }
                        } else {
                            if (data.data.memberType == "2") {
                                //不是会员
                                if (data.data.MlimitCountStatus == false) {
                                    //表示三套已经看完
                                    this.modelDown = 1;
                                } else {
                                    if (this.bolClick) {

                                        // this.isTodayCount = true;
                                        // setTimeout(function() {
                                        //     that.isTodayCount = false;
                                        // }, 2000);

                                        //$1("#todayCount").fadeIn();

                                        setTimeout(function() {
                                            $1("#todayCount").fadeOut();
                                        }, 2000);


                                        this.bolClick = false;
                                    }
                                    this.checkedLook = true;
                                    this.lookFun(fun);
                                }
                            } else {
                               //会员
                               if (this.bolClick) {


                                    // this.isTodayCount = true;
                                    // setTimeout(function() {
                                    //     that.isTodayCount = false;
                                    // }, 2000);

                                    //$1("#todayCount").fadeIn();

                                    setTimeout(function() {
                                        $1("#todayCount").fadeOut();
                                    }, 2000);


                                    this.bolClick = false;
                                }
                                this.checkedLook = true;
                                this.lookFun(fun);
                            }
                        }
                    // }
                }
            } else if (data.data.code == "201") {
                localStorage.clear();
                layer.open({
                    content: "请先登录",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
                this.$router.push({
                    path: "/login",
                    query: { shopDetail: 1, shopId: this.id }
                });
            } else {
                layer.open({
                    content: "系统繁忙，请稍后再试",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
            }
        }).catch(err => {
            console.log(err);
        });
    },
    
    
    //=====
    //直拨店主电话，查看详细地址，地图
    threeFunNew(type) {
        let that = this;
        
        if (localStorage.token == null) {
            layer.open({
                content: "请先登录",
                skin: "msg",
                time: 2 //2秒后自动关闭
            });
            this.$router.push({
                path: "/login",
                query: { shopDetail: 1, shopId: this.id }
            });
        } else {
            axios(this.changeData() + "/shop/shopCheckedRecords", {
                method: "post",
                params: {
                    cityId: this.appCityId || sessionStorage.cityId,
                    shopId: this.id,
                    type: "1",
                }
            }).then(data => {
                console.log(data);
                if (data.data.code == "101") {
                   
                        this.numIndex = data.data.count;
                        this.pvCount = data.data.pvCount;
                        if (this.checkedLook == true) {
                            //已经看过
                            //this.lookFun(fun);
                            this.goMessageuser(type);
                        } else { 
                            if (data.data.countStatus == false) {
                                //已经看了10次了
                                this.modelTishi = 1;
                            } else {
                               //还有剩余次数
                           	  this.goMessageuser(type);
                            }
                        }
                } else if (data.data.code == "201") {
                    localStorage.clear();
                    layer.open({
                        content: "请先登录",
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                    this.$router.push({
                        path: "/login",
                        query: { shopDetail: 1, shopId: this.id }
                    });
                } else {
                    layer.open({
                        content: "系统繁忙，请稍后再试",
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                }
            }).catch(err => {
                console.log(err);
            });
        }
    },
    //app端在线聊 检测
    threeAppFunNew(type) {
    		console.log("====type : "+type);
        let that = this;
        axios(this.changeData() + "/shop/shopCheckedRecords", {
            method: "post",
            params: {
                cityId: this.appCityId,
                shopId: this.id,
                type: "1",
                paramPhone: this.appParamPhone,
                authentication: this.ryUserId
                // roof: "0"
            }
        }).then(data => {
            // console.log(data);
            if (data.data.code == "101") {
                
                    this.numIndex = data.data.count;
                    this.pvCount = data.data.pvCount;
                    if (this.checkedLook == true) {
                        //已经看过
                        //this.lookFun(fun);
                        this.goMessageuser(type);
                    } else { 
                        if (data.data.countStatus == false) {
                            //已经看了10次了 用完剩余次数
                            //this.modelTishi = 1;
                            if(this.appType == "android"){
                            		//安卓调用app原生弹框
                            		this.s(); 
                            }else{
                            		//ios调用app原生弹框
                            		webkit.messageHandlers.iosPopView.postMessage(null)
                            }
                        } else {
                           //还有剩余次数
                           this.goMessageuser(type);
                        }
                }
            } else if (data.data.code == "201") {
                localStorage.clear();
                layer.open({
                    content: "请先登录",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
                this.$router.push({
                    path: "/login",
                    query: { shopDetail: 1, shopId: this.id }
                });
            } else {
                layer.open({
                    content: "系统繁忙，请稍后再试",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
            }
        }).catch(err => {
            console.log(err);
        });
    },
    
    s(){
     	//调用Java的back()方法
	    var result =window.android.back();
	    document.getElementById("p").innerHTML=result;
    },
    //====

    lookFun(fun) {
        var that = this;
        if (fun == "tel" || fun == "6") {
            //window.location.href = "tel:" + this.iphone;
            this.telPhone(fun);
        } else if (fun == "map") {
             if(this.appType == "ios"){
                window.webkit.messageHandlers.currentCookiesMap2.postMessage({
                    "body": "buttonActionMessage"
                });
            }else{
                setTimeout(function() {
                    that.$router.push({
                        path: "/shopMap",
                        query: {
                            shopDetail: 1,
                            shopOther: that.msg,
                            collect: that.$route.query.collect,
                            shopId: that.id,
                            lng: that.lng,
                            lat: that.lat,
                            areaName: that.shopDetailArr.areaName,
                            road: that.shopDetailArr.road,
                            realAddress: that.realAddress
                        }
                    });
                }, 1000);
            }
        } else if (fun == "adr") {
            this.add = 2;
        }
    },

    // 获取业主电话接口
    phoneData() {
        let url = this.changeData() + "/shop/m/selectPhoneForUnauth";
        axios(url, {
            method: "post",
            params: {
                shopId: this.id,
                type: "0",
                // paramPhone: this.appParamPhone
            }
        }).then(data => {
            // console.log(data.data.phone);
            if (data.data.code == "101") {
                this.iphone = data.data.phone;
            }

        }).catch(err => {
            console.log(err);
        });
    },

    // 直拨店主电话
    telPhone(fun) {

        let _this = this;

        // alert(this.guWenTel);

        if(this.appType == "ios"){
            
            if(this.ryUserId){

               if(fun == "6"){
                		window.location.href = "tel:" + this.guWenTel;
                }else{
                		window.location.href = "telf:" + this.guWenTel;
                }

                let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
                axios(url,{
                    method: 'post',
                    params:{
                        senderId: this.ryUserId, //发送人ID
                        targetIds: this.guWenId, //接收人ID
                        shopId: this.id, //商铺ID
                        type: '0_15',
                        // source: "1",//  string  是   触发来源 1：详情 2：推荐
                    }
                }).then(data => {
                    console.log(data);
                     
                }).catch(err => {
                    console.log(err)
                });
            }else{
                window.webkit.messageHandlers.currentCookiesMap.postMessage({
                    "body": "buttonActionMessage"
                });
            }
        }else if(this.appType == "android"){

             if(this.ryUserId){
                // 2 是拨打电话
                if(fun == "6"){
                		return AndroidDial.showToast("6");
                }else{
                		return AndroidDial.showToast("2");
                }

                let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
                axios(url,{
                    method: 'post',
                    params:{
                        senderId: this.ryUserId, //发送人ID
                        targetIds: this.guWenId, //接收人ID
                        shopId: this.id, //商铺ID
                        type: '0_15',
                        // source: "1",//  string  是   触发来源 1：详情 2：推荐
                    }
                }).then(data => {
                    console.log(data);
                     
                }).catch(err => {
                    console.log(err)
                });

            }else{
                // 未登录
                return AndroidDial.showToast("0");
            }
        }else{
            if (localStorage.token == null) {
                layer.open({
                    content: "请先登录",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
                this.$router.push({
                    path: "/login",
                    query: { shopDetail: 1, shopId: this.id }
                });
            }else{

                this.addSortFun();

                let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
                axios(url,{
                    method: 'post',
                    params:{
                        senderId: localStorage.rcUserId, //发送人ID
                        targetIds: this.guWenId, //接收人ID
                        shopId: this.id, //商铺ID
                        type: '0_15',
                    }
                }).then(data => {

                }).catch(err => {
                    console.log(err)
                });

                 window.location.href = "tel:" + this.guWenTel;

            }
        }
    },

    addSortFun(){

      let _this = this;

      let url = _this.changeData() + '/shop/addSort';
        axios(url,{
            method: 'post',
            params:{
                shopId: this.id, //商铺ID
            }
        }).then(data => {
          
        }).catch(err => {
            console.log(err)
        });

    },

    // 点击查看详细地址
    address() {
        let fun = "adr";
        if(this.appType == "ios"){
            if(this.ryUserId){
                this.threeAppFun(fun);
            }else{
                window.webkit.messageHandlers.currentCookiesMap.postMessage({
                    "body": "buttonActionMessage"
                });
            }
        }else if(this.appType == "android"){
            if(this.ryUserId){
                this.threeAppFun(fun);
            }else{
                // 未登录
                return AndroidDial.showToast("0");
            }
        }else{
            this.threeFun(fun);
        }
    },
    
    // 点击地图
    mapBtn() {

        let fun = "map";
        if(this.appType == "ios"){
            if(this.ryUserId == ''){
                window.webkit.messageHandlers.currentCookiesMap.postMessage({
                    "body": "buttonActionMessage"
                });
            }
            if(this.ryUserId){
                this.threeAppFun(fun);
            }
        }else if(this.appType == "android"){
            if(this.ryUserId){
                this.threeAppFun(fun);
            }else{
                // 未登录
                return AndroidDial.showToast("0");
            }
        }else{
            
            this.threeFun(fun);
        }
    },

    // 点击收藏
    shoucang(e) {
        var that = this;
        // let USERS = window.localStorage.getItem("iphone");

        if ($(e.srcElement).hasClass("cur")) {
            var data1 = {
                shopId: this.id
            };
            this.$http.post(
                this.changeData() + "/member/auth/cancelCollection",
                qs.stringify(data1)
            ).then(function(res) {
                // console.log(res)
                if (res.data.code == "101") {
                    $(e.srcElement).removeClass("cur");
                    layer.open({
                        content: "取消收藏",
                        skin: "msg",
                        time: 2
                    });
                } else if (res.data.code == "201") {
                    localStorage.clear();
                    layer.open({
                        content: "请先登录",
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                    that.$router.push({
                        path: "/login",
                        query: { shopDetail: 1, shopId: that.id }
                    });
                } else {
                    layer.open({
                        content: "系统繁忙，请稍后再试",
                        skin: "msg",
                        time: 2
                    });
                }
            }.bind(this)).catch(function(err) {
                console.log("商店列表页面错误：", err);
            });
        } else {
            var data2 = {
                shopId: this.id
            };
            this.$http.post(
                this.changeData() + "/member/auth/saveCollection",qs.stringify(data2)).then(function(res) {
                    // console.log(res)
                    this.shopIdObj = res.data.shopCollId;
                    // console.log(this.shopIdObj);
                    if (res.data.code == "101") {
                        $(e.srcElement).addClass("cur");
                        layer.open({
                          content: "收藏成功",
                          skin: "msg",
                          time: 2
                        });
                    } else if (res.data.code == "201") {
                        localStorage.clear();
                        layer.open({
                            content: "请先登录",
                            skin: "msg",
                            time: 2 //2秒后自动关闭
                        });
                        that.$router.push({
                            path: "/login",
                            query: { shopDetail: 1, shopId: that.id }
                        });
                    } else {
                        layer.open({
                          content: "系统繁忙，请稍后再试",
                          skin: "msg",
                          time: 2
                        });
                    }
                }.bind(this)).catch(function(err) {
                    console.log("商店列表页面错误：", err);
                });
            }
        },

    // 去会员购买页面
    goBuymember() {
        this.$router.push({ path: "/buymember" });
    },

    // 为您推荐
    go(item) {

        if(this.appType == "ios"){

            window.location.href = "shopId:" + item.id;

        }else if(this.appType == "android"){

            return AndroidDial.showToast(item.id);

        }else{

            // window.location.href = "http://" + window.location.host + "/shopDetail?" + "shopId=" + item.id + "&shopDetail=" + 1 + "&type=" + item.type;

            window.location.href = "http://" + window.location.host + "/shopDetail?" + "shopId=" + item.id + "&shopDetail=" + 1;

            window.scrollTo("0", "0");
        }
        
    }
  },
  watch: {
    telVal() {
        if (this.telVal.length == 13) {
            this.isTelError = true;
        } else {
            this.isTelError = false;
        }

        let reg = /^1([38]\d|4[57]|5[0-35-9]|7[01-8])(\-\d{4}){2}$/;

        if (!reg.test(this.telVal)) {
            this.isTelError = false;
        } else {
            this.isTelError = true;
        }
    }
  }
};
</script>
<style>
.layui-m-layer-tishi .layui-m-layercont {
  padding: 35px 30px;
}
.layui-m-layer-tishi h2 {
  font-size: 0.34rem !important;
  font-weight: bold !important;
  margin-bottom: 0.3rem;
  color: #333;
}
.layui-m-layer-tishi p {
  font-size: 0.3rem;
  color: #333;
}
.layui-m-layer-tishi p span {
  color: #e8584f;
}
.layui-m-layer-tishi .layui-m-layerbtn span {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background: #64aaff;
  font-size: 0.34rem;
  color: #fff;
}
.layui-m-layer-tishi .layui-m-layerbtn span:nth-of-type(1) {
  background: #f7f8fa;
  color: #999;
}
.layui-m-layer-tishi .layui-m-layerbtn span:nth-of-type(2) {
  border-radius: 0 0 5px 0;
}

.layui-m-layer-tel1 .layui-m-layercont {
  padding: 35px 30px;
}
.layui-m-layer-tel1 h2 {
  font-size: 0.34rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.3rem;
}
.layui-m-layer-tel1 p {
  font-size: 0.3rem;
  text-align: center;
  color: #333;
}
.layui-m-layer-tel1 p span {
  color: #e8584f;
}
.layui-m-layer-tel1 .layui-m-layerbtn {
  background: #64abff;
}
.layui-m-layer-tel1 .layui-m-layerbtn span {
  color: #fff !important;
  font-size: 0.34rem;
}
</style>
<style lang="scss" type="text/scss" scoped>
/*@import "../../../static/css/shopList.scss";*/

.shopdetail-wrap{
    width: 7.5rem;
    /*width: 100%;*/
    padding-bottom: 1.68rem;
    background: #fff;
    margin: 0 auto;
    p,h1,h2,h3,h4,h5,h6,span,dl,dt,dd,ul,ol,li,div{font-family:  PingFangSC-Regular,PingFang SC;}
}

/* header */
.shopdetail-header{
    width: 6.5rem;
    padding: 0 .5rem;
    height: .88rem;
    background: #fff;
    position: fixed;
    left: auto;
    top: 0;
    border-bottom: 2px solid #f8f8f8;
    z-index: 1000;
    .navBack{
        width: 0.2rem;
        height: 0.36rem;
        margin-top: .3rem;
    }
    ul{
        float: right;
        margin-top: .26rem;
        li{
            float: left;
            margin-left: .4rem;
            width: .4rem;
            height: .4rem;
            img{
                width: .4rem;
                height: .4rem;
            }
        }
        .myshou{
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            margin-top: .08rem;
            background: url("../../../static/images/shopDetail/collect.png") no-repeat;
            background-size: 0.4rem 0.4rem;
            &.cur {
                background-image: url("../../../static/images/shopDetail/collect-bg.png");
            }
        }
    }
}

/* APP下载页 */
.downing {
    width: 6.5rem;
    /*width: 100%;*/
    height: 0.88rem;
    padding: 0 0.5rem;
    line-height: 0.88rem;
    background: rgba(255, 255, 255, 0.8);
    position: fixed;
    top: .88rem;
    left: auto;
    background: #fff;
    z-index: 1000;
    span {
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        background: url("../../../static/images/shopDetail/xiazai.png") no-repeat;
        -webkit-background-size: 0.5rem 0.5rem;
        background-size: 0.5rem 0.5rem;
        vertical-align: middle;
        margin-right: .2rem;
    }
    b {
        font-size: 0.24rem;
        display: inline-block;
        vertical-align: middle;
        color: #666;
    }
    a {
        display: inline-block;
        vertical-align: middle;
        width: 1.4rem;
        height: 0.4rem;
        line-height: 0.4rem;
        border: 1px solid #64abff;
        color: #64abff;
        border-radius: 0.1rem;
        text-align: center;
        margin: 0 0.2rem;
        font-size: 0.24rem;
    }
    s {
        display: inline-block;
        vertical-align: middle;
        width: 0.28rem;
        height: 0.28rem;
        background: url("../../../static/images/shopDetail/close.png") no-repeat;
        -webkit-background-size: 0.28rem 0.28rem;
        background-size: 0.28rem 0.28rem;
    }
}

/* 查看次数 */
.todayCount {
    width: 6.5rem;
    padding: 0 .5rem;
    height: 1rem;
    position: fixed;
    left: auto;
    top: .88rem;
    z-index: 1000;
    background: #fff;
    box-shadow:0px 2px 4px 1px rgba(226,226,226,0.37);
    dl{
        width: 6.5rem;
        height: .84rem;
        position: relative;
        padding-top: .16rem;
        dt{
            float: left;
            width: .6rem;
            height: .6rem;
            margin-right: .2rem;
            img{
                width: .6rem;
                height: .6rem;
            }
        }
        dd{
            float: left;
            h5{
                font-size: .24rem;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: #333;
                line-height: .24rem;
                margin: .06rem auto .02rem;
            }
            p{
                font-size: .2rem;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: #666;
            }
        }
        span{
            width: 1.4rem;
            height: .58rem;
            border-radius: 6px;
            border: 1px solid #f5a623;
            display: inline-block;
            position: absolute;
            right: 0;
            top: .2rem;
            font-size: .24rem;
            font-weight: 400;
            color: #f5a623;
            text-align: center;
            line-height: .58rem;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            a{
                font-size: .28rem;
                color: #4a90e2;
                font-size: .24rem;
                font-weight: 400;
                color: #f5a623;
                line-height: .58rem;
            }
        }
    }
}

/* content */
.shopdetail-content{
    width: 6.5rem;
    /*width: 100%;*/
    padding: 0 .5rem;
    padding-top: .2rem;
    padding-bottom: .8rem;
    .content-top{
        margin-bottom: .3rem;
        p{
            font-size: .26rem;
            font-weight: 400;
            color: #cdcbcb;
            line-height: .36rem;
        }
        h1{
            font-size: .4rem;
            font-weight: 600;
            color: #333;
            line-height: .56rem;
            margin-top: .14rem;
            min-height: .56rem;
        }
        div{
            width: 6.5rem;
            height: .5rem;
            overflow: hidden;
            margin-top: .2rem;
/*            margin-bottom: .3rem;*/
            ul{
                height: .8rem;
                width: 100%;
                display: box;
                display: -webkit-box;
                overflow-x: scroll;
                -webkit-overflow-scrolling: touch;
                li{
                    height: .44rem;
                    display: block;
                    padding: 0 0.12rem;
                    line-height: .44rem;
                    border: 1px solid #4a90e2;
                    color: #4a90e2;
                    font-size: .2rem;
                    font-weight:600;
                    color: #4a90e2;
                    margin-right: .2rem;
                    box-sizing: border-box;
                }
            }
        }
    }
    /*地址*/
    .address {
        width: 6.5rem;
        padding: .3rem 0 .4rem;
        border-bottom: 2px solid #f8f8f8;
        position: relative;
        h3{
            width: 5rem;
            font-size: .32rem;
            font-weight: 600;
            color: #333;
            line-height: .44rem;
        }
        .one {
            width: 5rem;
            float: left;
            &.cur {
                width: 5rem;
               .look {
                    width: 5rem;
                }
            }
            p{
                font-size: .3rem;
                font-weight: 400;
                color: #333;
                line-height: .42rem;
                margin-top: .06rem;
            }
        }
        .two {
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            display: block;
            width: 2.1rem;
            padding: .01rem 0;
            color: #fff;
            text-align: center;
            background: #64aaff;
            border-radius: 4px;
            font-size: 0.26rem;
            margin-top: .1rem;
        }
        .map {
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            position: absolute;
            right: 0rem;
            top: .3rem;
            width: 1rem;
            height: 1rem;
            background: url("../../../static/images/shopDetail/map.png") no-repeat;
            background-size: 1rem 1rem;
            .iframe {
                width: 7.5rem;
                height: 13.3rem;
                position: fixed;
                left: 0;
                top: 0;
                z-index: 99999;
            }
            a {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
    /*价格*/
    .price {
        width: 6.5rem;
        padding-top: .32rem;
        display: flex;
        dl {
            width: 35%;
            flex-direction:row; 
            overflow: hidden;
            dt {
                font-size: .36rem;
                font-weight: 600;
                color: #f5a623;
                line-height: .5rem;
            }
            dd {
                font-size: .24rem;
                font-weight: 400;
                color: #999;
                line-height: .34rem;
                margin: .14rem 0 .54rem;
            }
        }
        .dl3{
            width: 30%;
        }
    }
    /*商铺类型*/
    .shop-type{
        padding-bottom: .6rem;
        border-bottom: 2px solid #f8f8f8;
        div{
            width: 6.5rem;
            line-height: .8rem;
            border: 2px solid rgba(74,144,226,.5);
            text-align: center;
            border-radius: 6px;
            img{
                width: .32rem;
                height: .32rem;
                position: relative;
                left: 0;
                top: -.01rem;
            }
            span{
                font-size: .28rem;
                font-weight: 400;
                color: #4a90e2;
                margin-left: .1rem;
            }
        }
        dl{
            width: 6.5rem;
            margin-top: .4rem;
            display: flex;
            i{
                width: .32rem;
                height: .32rem;
                line-height: .4rem;
                position: relative;
                left: 0;
                top: -.02rem;
                img{
                    width: .32rem;
                    height: .32rem;
                }
            }
            dt{
                font-size: .28rem;
                font-weight: 400;
                color: #999;
                line-height: .4rem;
                margin: 0 .74rem 0 .18rem;
            }
            dd{
                width: 4rem;
                text-align: justify;
                font-size: .28rem;
                font-weight: 400;
                color: #333;
                line-height: .4rem;
            }
        }
    }
    /* 顾问说铺*/
    .consultant{
        dl{
            height: 1.1rem;
            padding-top: .18rem;
            .consultant-img{
                width: .8rem;
                height: .8rem;
                float: left;
                border-radius: 50%;
            }
            dt{
                float: left;
                margin-left: .36rem;
                h3{
                    font-size: .28rem;
                    font-weight: 400;
                    color: #333;
                    line-height: .4rem;
                }
                h5{
                    color: #333;
                    font-size: .28rem;
                    font-weight: 600;
                    color: rgba(51,51,51,1);
                    line-height: .4rem;
                }
            }
            dd{
                width: 2.2rem;
                height: .6rem;
                float: right;
                margin-top: .1rem;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                img{
                    width: 2.2rem;
                    height: .6rem;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                }
            }
        }
       /* pre{
            width: 5.9rem;
            padding: .3rem;
            background: #fef7ea;
            text-align: justify;
            font-size: .26rem;
            font-weight: 400;
            color: #333;
            line-height: .5rem;
            border-radius: 6px;
            word-break: break-all;
        }*/
        p{
            width: 5.9rem;
            padding: .3rem;
            background: #fef7ea;
            text-align: justify;
            font-size: .26rem;
            font-weight: 400;
            color: #333;
            line-height: .5rem;
            border-radius: 6px;
            word-break: break-all;
            white-space: pre-line;
        }
    }
    /*已有证照*/
    .certification{
        width: 6.5rem;
        height: 1.9rem;
        overflow: hidden;
        padding-top: .3rem;
        ul{
            width: 100%;
            height: 2.1rem;
            display: box;
            display: -webkit-box;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
            li{
                display: block;
                width: 1.8rem;
                height: 1.84rem;
                margin-right: .46rem;
                img{
                    width: 1.8rem;
                    height: 1.24rem;
                    margin-bottom: .1rem;
                }
                p{
                    display: inline-block;
                    width: 1.6rem;
                    height: .46rem;
                    line-height: .46rem;
                    padding: 0 .1rem;
                    overflow: hidden;
                    text-align: center;
                    font-size: .22rem;
                    font-weight: 400;
                    color: #333;
                    background: #fef7ea;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

            }
        }
    }
    /* 配套设施*/
    .sheshi-list {
        width: 6.5rem;
        padding: .3rem 0 .5rem;
        flex-wrap: wrap;
        justify-content: space-around;
        dl {
            text-align: center;
            display: none;
            width: 20%;
            margin-top: .3rem;
            float: left;
            dt {
                width: 0.5rem;
                height: 0.5rem;
                margin: 0 auto;
                margin-bottom: 0.2rem;
                width: 0.5rem;
                height: 0.5rem;
                background: url("../../../static/images/shopDetail/dian.png")no-repeat;
                background-size: 0.5rem 0.5rem;
                text-align: center;
                &.dian {
                    background-image: url("../../../static/images/shopDetail/dian-bg.png");
                }
                &.pai {
                    background-image: url("../../../static/images/shopDetail/pai-bg.png");
                }
                &.yan {
                    background-image: url("../../../static/images/shopDetail/yan-bg.png");
                }
                &.xia {
                    background-image: url("../../../static/images/shopDetail/xia-bg.png");
                }
                &.shang {
                    background-image: url("../../../static/images/shopDetail/shang-bg.png");
                }
                &.wai {
                    background-image: url("../../../static/images/shopDetail/wai-bg.png");
                }
                &.ting {
                    background-image: url("../../../static/images/shopDetail/ting-bg.png");
                }
                &.mei {
                    background-image: url("../../../static/images/shopDetail/mei-bg.png");
                }
                &.tian {
                    background-image: url("../../../static/images/shopDetail/tian-bg.png");
                }
                &.ming {
                    background-image: url("../../../static/images/shopDetail/ming-bg.png");
                }
                &.wzz {
                  background-image: url("../../../static/images/shopDetail/wzz.png");
                }
                &.wangluo {
                  background-image: url("../../../static/images/shopDetail/wangluo.png");
                }
                &.nuanqi {
                  background-image: url("../../../static/images/shopDetail/nuanqi.png");
                }
                &.wuyefei {
                  background-image: url("../../../static/images/shopDetail/wuyefei.png");
                }
                &.zhuanxiu {
                  background-image: url("../../../static/images/shopDetail/zhuanxiu.png");
                }
            }
            &.cur {
              display: block;
              dt {
                &.dian {
                  background-image: url("../../../static/images/shopDetail/dian.png");
                }
                &.pai {
                  background-image: url("../../../static/images/shopDetail/pai.png");
                }
                &.yan {
                  background-image: url("../../../static/images/shopDetail/yan.png");
                }
                &.xia {
                  background-image: url("../../../static/images/shopDetail/xia.png");
                }
                &.shang {
                  background-image: url("../../../static/images/shopDetail/shang.png");
                }
                &.wai {
                  background-image: url("../../../static/images/shopDetail/wai.png");
                }
                &.ting {
                  background-image: url("../../../static/images/shopDetail/ting.png");
                }
                &.mei {
                  background-image: url("../../../static/images/shopDetail/mei.png");
                }
                &.tian {
                  background-image: url("../../../static/images/shopDetail/tian.png");
                }
                &.ming {
                  background-image: url("../../../static/images/shopDetail/ming.png");
                }
                &.wzz {
                  background-image: url("../../../static/images/shopDetail/wzz.png");
                }
                &.wangluo {
                  background-image: url("../../../static/images/shopDetail/wangluo.png");
                }
                &.nuanqi {
                  background-image: url("../../../static/images/shopDetail/nuanqi.png");
                }
                &.wuyefei {
                  background-image: url("../../../static/images/shopDetail/wuyefei.png");
                }
                &.zhuanxiu {
                  background-image: url("../../../static/images/shopDetail/zhuanxiu.png");
                }

              }
              dd {
                font-size: .26rem;
                font-weight:400;
                color: #333;
                line-height: .36rem;
                margin-top: .12rem;
              }
            }
          }
        }
}
/*公共导航*/
.common-title{
    width: 6.5rem;
    padding: .4rem 0 .2rem;
    border-bottom: 2px solid #f8f8f8;
    i{
        /*width: .4rem;
        height: .4rem;
        line-height: .4rem;*/
        img{
            width: .4rem;
            height: .34rem;
            position: relative;
            top: -.02rem;
            left: 0;
        }
    }
    .xkz-icon{
        /*width: .4rem;
        height: .34rem;
        line-height: .34rem;*/
        img{
            width: .4rem;
            height: .32rem;
        }
    }
    /*.sheshi-icon{
        img{
            width: .4rem;
            height: .34rem;
        }
    }
    .recommend-icon{
        img{
            width: .4rem;
            height: .34rem;
        }
    }*/

    span{
        font-size: .32rem;
        font-weight: 400;
        color: #333;
        line-height: .44rem;
        margin-left: .24rem;
    }
}
/* 轮播图 */
.content-lbt{
    width: 6.5rem;
    height: 4rem;
    border-radius: 4px;
    .lbt-small {
        width: 100%;
        height: 4rem;
        overflow: hidden;
        position: relative;
        border-radius: 4px;
        .swiper-container {
            width: 100%;
            height: 4rem;
        }
        .swiper-slide {
            width: 6.5rem !important;
            height: 4rem;
            border-radius: 4px;
            img {
                width: 6.5rem;
                height: 4rem;
               /* min-width: 6.5rem;
                min-height: 4rem;
                border-radius: 4px;
                margin-top: -40%;*/
                /*margin-left: -50%;*/
            }
        }
        .lbt-num{
            width: 1.08rem;
            height: .4rem;
            background: rgba(0,0,0,0.5);
            position: absolute;
            bottom: .14rem;
            right: .22rem;
            z-index: 9;
            color: #fff;
            text-align: center;
            border-radius: 25px;
            font-size: .26rem;
            font-weight: 400;
            line-height: .4rem;
        }
    }
    .bannerBig {
        display: none;
        width: 7.5rem;
        height: 100%;
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
        background: #010101;
        z-index: 10000;
        .swiper-top {
            width: 7.5rem;
            height: 0.9rem;
            line-height: 0.9rem;
            text-align: center;
            font-size: 0.34rem;
            color: #fff;
            font-weight: bold;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1000;
            /*background: #141414;*/
            background: #000;
            span {
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                position: absolute;
                left: 0.2rem;
                top: 0.3rem;
                width: 0.36rem;
                height: 0.36rem;
                background: url("../../../static/images/common/back-write.png") no-repeat;
                background-size: 0.36rem 0.36rem;
            }
        }
        .app-close{
            width: .6rem;
            height: .6rem;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            position: absolute;
            right: .3rem;
            top: 2rem;
            z-index: 1000;
            img{
                width: .46rem;
                height: .46rem;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            }
        }
        .swiper-bottom {
            width: 7.5rem;
            position: absolute;
            left: 0;
            bottom: 0;
            height: 0.9rem;
            line-height: 0.9rem;
            text-align: center;
            font-size: 0.34rem;
            font-weight: bold;
            text-align: center;
            color: #fff;
            z-index: 1000;
        }
        .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide {
                width: 100%;
                height: 100%;
                position: relative;
                img {
                    width: 100%;
                    height: 5.56rem;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -3.75rem;
                    margin-top: -2.78rem;
                    text-align: center;
                }
            }
        }
    }
    .video-wrap {
        width: 7.5rem;
        height: 100%;
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
        background: #010101;
        z-index: 100000;
        display: none;
        .swiper-top {
            width: 7.5rem;
            height: 0.9rem;
            line-height: 0.9rem;
            text-align: center;
            font-size: 0.34rem;
            color: #fff;
            font-weight: bold;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1000;
            /*background: #141414;*/
            background: #000;
            span {
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                position: absolute;
                left: 0.2rem;
                top: 0.3rem;
                width: 0.36rem;
                height: 0.36rem;
                background: url("../../../static/images/common/back-write.png") no-repeat;
                background-size: 0.36rem 0.36rem;
            }
        }
        .app-close{
            width: .6rem;
            height: .6rem;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            position: absolute;
            right: .3rem;
            top: 2rem;
            z-index: 1000;
            img{
                width: .46rem;
                height: .46rem;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            }
        }
        video {
            margin-top: 3.5rem;
        }
    }
}
.content-lbt .swiper-container .videoImgWrap {
    width: 6.5rem;
    height: 4rem;
    position: absolute;
    left: 0;
    right: 0;
    .videoImg {
        width: 1.2rem;
        height: 1.2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.6rem;
        margin-left: -0.6rem;
    }
}

/* footer */
.shopdetail-footer{
    width: 6.5rem;
    padding: 0 .5rem;
    height: 1.68rem;
    background: #fff;
    position: fixed;
    left: auto;
    bottom: 0;
    border-bottom: 2px solid #f8f8f8;
    z-index: 1000;
    .consultant2-img{
        width: 1.58rem;
        height: 1.58rem;
        position: relative;
        left: 0;
        top: -.5rem;
        border-radius: 50%;
    }
    ul{
        float: right;
        margin-top: .2rem;
        li{
            width: 2.24rem;
            float: left;
            text-align: center;
            line-height: .8rem;
            font-size: .32rem;
            font-weight: 400;
            color: #fff;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            img{
                width: .36rem;
                height: .36rem;
            }
        }
        .li1{
            background: url("../../../static/images/shopDetail/footer1.png") no-repeat;
            background-size: 2.24rem .86rem;
        }
        .li2{
            background: url("../../../static/images/shopDetail/footer2.png") no-repeat;
            background-size: 2.24rem .86rem;
        }
    }
}

/* 弹窗 */
.popup-wrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000000000;
    .popup-box {
        width: 6.6rem;
        height: 3.6rem;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 30%;
        margin-left: -3.3rem;
        border-radius: 10px;
        overflow: hidden;
        h3 {
            color: #333;
            font-size: 0.34rem;
            text-align: center;
            margin-top: 0.3rem;
            margin-bottom: 0.2rem;
        }
        p {
            text-align: center;
            color: #333;
            font-size: 0.3rem;
        }
        ul {
            width: 100%;
            height: 0.88rem;
            position: absolute;
            bottom: 0;
            left: 0;
            li {
                width: 50%;
                line-height: 0.88rem;
                float: left;
                background: #64abff;
                color: #fff;
                font-size: 0.34rem;
                text-align: center;
            }
            .li1 {
                background: #f7f8fa;
                color: #898989;
            }
        }
    }
}

.model-tishi,.model-down {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99999;
    &.model-down {
      .model {
        height: 3.8rem;
        .close {
          width: 0.32rem;
          height: 0.32rem;
          background: url("../../../static/images/shopDetail/close.png")
            no-repeat;
          background-size: 0.32rem 0.32rem;
          position: absolute;
          left: 6.2rem;
          top: 0.05rem;
        }
      }
    }
    .model {
      width: 6.6rem;
      height: 3.6rem;
      background: #fff;
      position: absolute;
      left: 50%;
      margin-left: -3.3rem;
      top: 50%;
      margin-top: -1.9rem;
      border-radius: 0.1rem;
      h2 {
        text-align: center;
        font-size: 0.34rem;
        color: #333;
        font-weight: bold;
        margin-bottom: 0.3rem;
        margin-top: 0.48rem;
      }
      p {
        text-align: center;
        width: 5.5rem;
        margin: 0 auto;
        .red {
          color: #e8584f;
        }
      }
      div {
        width: 6.6rem;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 0.88rem;
        line-height: 0.88rem;
        span {
          display: inline-block;
          width: 50%;
          font-size: 0.34rem;
          background: #eaeaea;
          border-radius: 0 0 0 5px;
          text-align: center;
          color: #898989;
          float: left;
          a {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
        b {
          display: inline-block;
          width: 50%;
          background: #64abff;
          border-radius: 0 0 5px 0;
          text-align: center;
          color: #fff;
          a {
            width: 100%;
            height: 100%;
            font-size: 0.34rem;
            color: #fff;
          }
        }
      }
    }
  }




/* 公共列表 */
.detail {
    width: 6.5rem;
    background: #fff;
}
.detail ul { width: 6.5rem; }
.detail ul li {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    width: 6.5rem;
    height: 1.72rem;
    padding: .3rem 0;
    border-bottom: 2px solid #f8f8f8; 
}
.detail ul li .wrap .img {
    width: 2.28rem;
    height: 1.72rem; 
    float: left;
    margin-right: .16rem;
    border-radius: 4px;
}
.detail ul li .wrap .img img {
    width: 2.28rem;
    height: 1.72rem; 
    border-radius: 4px;
}
.detail ul li .wrap .msg {
    width: 4rem;
    height: 1.72rem;
    float: right;
    position: relative;
}
.detail ul li .wrap .msg h4 {
    width: 4rem;
    height: .8rem;
    font-size: .28rem;
    font-weight:600;
    color: #333;
    line-height: .4rem; 
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.detail ul li .wrap .msg .tags{
    position: absolute;
    bottom: .5rem;
    left: 0;
    margin-top: .2rem;
}
.detail ul li .wrap .msg .tags span {
    display: inline-block;
    width: 1.2rem;
    height: .34rem;
    line-height: .3rem;
    text-align: center;
    border:1px solid #4a90e2;
    color: #4a90e2;
    font-size: .2rem;
    margin-right: .1rem; 
    float: left;
    box-sizing: border-box;
    overflow: hidden;
}
.detail ul li .wrap .msg p {
    width: 4rem;
    font-size: .28rem;
    font-weight: 600;
    color: #f5a623;
    line-height: .4rem;
    position: absolute;
    bottom: 0;
    left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/shop/shopDetail.vue